
import axios from 'axios'

export default {
  name: 'GetDropdownOptions',
  methods: {
    getDropdown (callbacks) {
      axios.get(process.env.API_BASE_URL + this.$getTeamsEndPoint + this.$route.params.league, {})
        .then(function (response) {
          callbacks = callbacks || [function () {}]
          callbacks.forEach((callback) => {
            if (callback.name.indexOf('setTeamDropdown') > -1) {
              callback(response)
            } else if (callback.name.indexOf('setTeamAndPossessionStartDropdown') > -1) {
              callback(response)
            } else {
              callback()
            }
          })
        })
        .catch((error) => {
          console.log(error)
          this.error = error
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/get_dropdown.js